export default "__VITE_PUBLIC_ASSET__c2e2c5ad__"